document.addEventListener("DOMContentLoaded", function () {
  if (typeof tippy === "undefined") {
    return;
  }

  document
    .querySelectorAll(".feature-with-tooltip")
    .forEach(function (element) {
      const template = element.previousElementSibling;

      if (template && template.classList.contains("tooltip-template")) {
        tippy(element, {
          allowHTML: true,
          placement: "top",
          theme: "dark",
          arrow: true,
          interactive: false,
          maxWidth: 300,
          content: template.innerHTML,
        });
      }
    });
});
